import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Training',
    path: '/training'
  }, {
    name: 'Socials',
    path: '/socials'
  }, {
    name: 'About',
    path: '/about'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname === path;
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black/95 backdrop-blur-sm border-b border-gray-800`} data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-63">
        <div className="flex items-center justify-between" data-id="element-64">
          {/* Logo */}
          <Link to="/" className="text-xl font-bold tracking-tight text-white hover:opacity-80 transition-opacity" data-id="element-65">
            ALEKS SZULC
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-66">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors duration-200 ${isActive(link.path) ? 'text-[#D4FF00]' : 'text-gray-300 hover:text-[#D4FF00]'}`} data-id="element-67">
                {link.name}
              </Link>)}
            <Link to="/apply" className="bg-[#D4FF00] text-black px-6 py-3 rounded-lg text-sm font-bold uppercase tracking-wide hover:bg-[#c4ef00] transition-all hover:scale-105 hover:shadow-lg hover:shadow-[#D4FF00]/20" data-id="element-68">
              Apply Now
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-69">
            {isMobileMenuOpen ? <X size={24} data-id="element-70" /> : <Menu size={24} data-id="element-71" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-black border-b border-gray-800 shadow-lg" data-id="element-72">
          <nav className="flex flex-col p-4 space-y-4" data-id="element-73">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-lg font-medium py-2 px-4 rounded-lg ${isActive(link.path) ? 'bg-gray-900 text-[#D4FF00]' : 'text-gray-300 hover:bg-gray-900'}`} data-id="element-74">
                {link.name}
              </Link>)}
            <Link to="/apply" className="bg-[#D4FF00] text-black text-center py-3 rounded-lg font-bold uppercase tracking-wide mt-4" data-id="element-75">
              Apply Now
            </Link>
          </nav>
        </div>}
    </header>;
}